/**
 * One account on one page (owner, 2026-10-12: "графіки по кожному акку — підписники, фоловери, переходи…"):
 * who it is and where it lives, its reading, then its numbers day by day and its posts — the dashboard
 * narrowed to this account, so the period picker and the lines are the same everywhere.
 */

import { Smartphone } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'

import { useT } from '../../i18n'
import { useApp } from '../../lib/context'
import { usePoll } from '../../lib/poll'
import { Card } from '../../ui/components'
import { Dashboard } from '../dashboard/Dashboard'
import { Crumbs } from '../layout/Section'
import { AccountSite } from './AccountSite'
import { DirectionChip, useDirectionName, useDirections } from './directions'
import { ProfileLine } from './ProfileReading'

export function AccountPage() {
  const t = useT()
  const m = t.accountPage
  const { id = '' } = useParams()
  const { api, authEpoch } = useApp()
  const accounts = usePoll(() => api.accounts(), 60000, [api, authEpoch])
  const dirs = useDirections()
  const nameOf = useDirectionName()
  const a = accounts.data?.accounts.find((x) => x.account_id === id)
  const dir = a?.direction_id ? dirs.byId.get(a.direction_id) : undefined
  return (
    <div className="page col">
      <Crumbs items={[
        { label: t.sections.directions, to: '/directions' },
        ...(dir ? [{ label: nameOf(dir), to: `/directions/${encodeURIComponent(dir.direction_id)}` }] : []),
        { label: a ? (a.email || `@${a.handle}`) : id },
      ]} />
      {accounts.data && !a && <Card><span className="warn-text">{m.unknown}</span></Card>}
      {a && (
        <Card title={a.email || `@${a.handle}`}
              sub={[a.handle && `@${a.handle}`, a.platform_name].filter(Boolean).join(' · ')}
              actions={a.device_id
                ? <Link className="btn-sm" to={`/phones?device=${encodeURIComponent(a.device_id)}`}>
                    <Smartphone className="ico" size={14} aria-hidden /> {m.openPhone}</Link>
                : undefined}>
          <div className="account-facts">
            {dir && <DirectionChip direction={dir} />}
            <span className={`account-state ${a.state}`}>{t.marketing.state[a.state] ?? a.state}</span>
            <span className="tiny dim">{m.onPhone(a.device_name || a.serial)}</span>
            {a.profile_url && <a className="tiny" href={a.profile_url} target="_blank" rel="noreferrer">{m.profile}</a>}
            <AccountSite account={a} onChanged={accounts.refresh} />
          </div>
          <ProfileLine account={a} onChanged={accounts.refresh} />
        </Card>
      )}
      {a && <Dashboard account={a.account_id} />}
    </div>
  )
}
